import * as React from 'react'
import I18n from '../../../../core/i18n'
import { agentService, utilService } from '../../../../core/services'
import { InputText, CheckBox } from '../../../atoms'
import AgentLayoutEdit from '../_layouts/edit'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

interface IProps {
  agent_role: any
  user: any
}

const FIELDS = {
  name: 'name',
  description: 'description',
  is_active: 'is_active',
}

const AgentRolesEdit: React.FC<IProps> = props => {
  const { data: agentRole } = utilService.getDataFromJson(props.agent_role)

  const handleSubmit = React.useCallback(
    async (initialValues, values) => {
      try {
        const { flush } = await agentService.updateAgentRole({
          id: agentRole.id,
          ...values,
        })
        window.flashMessages.addMessage({ text: flush.message, type: flush.type })
        location.href = '/agent/agent_roles'
      } catch (e) {
        // 403等はhttpClientインターセプターでモーダル表示済み
      }
    },
    [agentRole]
  )

  return (
    <AgentLayoutEdit
      model="agent_roles"
      title={`${I18n.t('generic.agent_roles')} - ${I18n.t('generic.edit')}`}
      fields={FIELDS}
      indexLink="/agent/agent_roles"
      formItems={
        <>
          <InputText
            required={true}
            name="name"
            defaultValue={agentRole.name}
            label={I18n.t('generic.name')}
          />
          <InputText
            name="description"
            defaultValue={agentRole.description || ''}
            label={I18n.t('generic.description')}
          />
          <CheckBox
            name="is_active"
            defaultChecked={agentRole.is_active}
            label={I18n.t('generic.active')}
          />
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AgentRolesEdit
